<template>
    <v-list-page
            show-panel sorting searching
            list-key="Departments"
            single-key="Department"
            :fields="fields"
            :actions="actions"
            :page-title="$root.__('Departments')"
            :params="params"
            @onItemClick="onItemClick">

    </v-list-page>
</template>

<script>
    // Import needed components
    import VListPage from '../components/VListPage';

    export default {
        components: {VListPage},
        data: function () {
            let self = this;

            return {
                fields: [
                    {
                        name: 'vics_department.id',
                        label: self.$root.__('ID'),
                        prop: 'id',
                        sort: true,
                        type: Number,
                        require: true,
                        formOrder: 1,
                        showInChildrenList: false,
                    },
                    {
                        name: 'vics_department.description',
                        label: self.$root.__('Description'),
                        prop: 'description',
                        value: function (val) {
                            return self.$root.convertHtmlToText(val).substr(0, 250) + '...';
                        },
                        type: String,
                        fieldType: 'textarea',
                        search: true,
                        description: true,
                        formOrder: 6,
                        showInChildrenList: false,
                    },
                    {
                        name: 'vics_department.title',
                        label: self.$root.__('Title'),
                        prop: 'title',
                        type: String,
                        sort: true,
                        search: true,
                        showInList: false,
                        title: true,
                        require: true,
                        formOrder: 2
                    },
                    {
                        name: 'courses_count',
                        label: self.$root.__('Courses Count'),
                        prop: 'courses_count',
                        showInList: false,
                    },
                ],
                actions: [
                    {
                        name: 'courses',
                        label: self.$root.__('Courses'),
                        render: function (department) {
                            return self.$root.__('Courses') + '<span class="chip count"><span class="chip-label">' +
                                (department.courses_count) + '</span></span>';
                        }
                    },
                ],
            };
        },
        computed: {
            params: function () {
                let self = this;

                let column = self.$store.state._departments.params.order.column;
                let direction = self.$store.state._departments.params.order.direction;
                let q = self.$store.state._departments.params.q;

                return {
                    q: q,
                    filters: {},
                    order: {column: column ? column : 'vics_department.id', direction: direction ? direction : 'ASC'}
                };
            },
        },
        methods: {
            onItemClick: function (index, department, action) {
                switch (action) {
                    case 'courses':
                        this.courses(department);
                        break;
                    case 'createurl':
                        this.createurl(department);
                        break;
                    default:
                }
            },
            courses: function (department) {
                let self = this;

                self.$f7.mainView.loadPage('/list-courses/?department_id=' + department.id);
            },
            createurl: function (department) {
                let self = this;

                self.$store.dispatch('DO',
                    {
                        task: 'departments/createurl',
                        data: {department_id: department.id},
                        callback: function () {
                            self.$f7.addNotification({
                                message: self.$root.__('Successfully updated!'),
                                hold: 3000,
                                button: {text: self.$root.__('Close'), color: 'blue', close: true}
                            });

                            self.$store.dispatch('GET', {key: 'Departments', id: department.id});
                        }
                    });
            },
        },
        created: function () {

        }
    }
</script>


// WEBPACK FOOTER //
// list-departments.vue?923f9888